import { IframelyResponse, IframelyApi } from 'apis/iframelyApi';
import React from 'react';
import { useEffect, useState } from 'react';
import LinkPreview from 'ui/elements/LinkPreview';
import Loading from 'ui/elements/Loading';
import { IResource, idle, isFetching, fetched, fetchError } from 'util/resource';

export default function EditLinkPreview({
  link,
  onRemove,
  onLinkValid,
}: {
  link: string;
  onRemove: () => void;
  onLinkValid: (link: string) => void;
}) {
  const [meta, setMeta] = useState<IResource<IframelyResponse>>(idle);

  useEffect(() => {
    setMeta(isFetching());
    IframelyApi()
      .get(link)
      .then(result => {
        setMeta(fetched(result));
        onLinkValid(link);
      })
      .catch(e => {
        setMeta(fetchError(e?.status));
      });
  }, [link]);

  if (meta.state === 'fetching') {
    return (
      <div className="u-flex text-small u-half-spacing-top">
        <Loading size={18} className="u-half-spacing-right" />
        Loading preview...
      </div>
    );
  }

  if (meta.state === 'fetched') {
    return <LinkPreview meta={meta.resource} url={link} onClose={onRemove} />;
  }
  if (meta.state === 'error') {
    return (
      <div style={{ fontWeight: 500, fontSize: '0.75rem' }} className="u-error-text">
        Cannot preview link. Please try another link or post as is.
      </div>
    );
  }
  return <></>;
}
